module.exports = __webpack_public_path__ + "img/thebigquiz.880f45eb.jpg";